module.exports = __webpack_public_path__ + "img/Transmission Oil.7e9d341c.png";